import { useLocation } from "react-router-dom";
import { policyDocuments } from "../Datas/policyData";
import PageMeta from "./PageMeta";

const staticMeta = {
  "/": ["Italian pantry, gathered with care", "Thoughtful Italian pantry staples for generous everyday tables."],
  "/about": ["Our story", "Meet the people, values, and sourcing approach behind our Italian pantry."],
  "/contact": ["Contact", "Contact customer care for product, order, shipping, or return questions."],
  "/faq": ["Frequently asked questions", "Answers about pickup, shipping, tracking, gifts, order support, and checkout."],
  "/gifts": ["Corporate gifts", "Thoughtful Italian pantry gifts for teams, clients, hosts, and celebrations."],
  "/recipes": ["Italian pantry recipes", "Original recipes and practical kitchen notes for a working Italian pantry."],
  "/journal": ["The pantry journal", "Ingredient knowledge, kitchen rituals, and stories for generous tables."],
  "/wholesale": ["Wholesale", "A focused Italian pantry assortment for thoughtful trade and hospitality partners."],
  "/shipping": ["Shipping & delivery", "Shipping rates, timing, destinations, and delivery help."],
  "/returns": ["Returns & refunds", "Eligibility, damaged-item support, returns, and refund timing."],
  "/privacy": ["Privacy policy", "How personal information is collected, used, and protected."],
  "/cookies": ["Cookie policy", "How browser storage and similar technologies are used."],
  "/terms": ["Terms & conditions", "Terms governing this demonstration ecommerce storefront."],
  "/policies": ["Store policies", "Browse all shopping, food safety, privacy, legal, and business policies."],
};

Object.entries(policyDocuments).forEach(([path, policy]) => {
  staticMeta[path] = [policy.title, policy.description];
});

function RouteMeta() {
  const { pathname } = useLocation();
  const meta = staticMeta[pathname];

  if (!meta) return null;
  return <PageMeta title={meta[0]} description={meta[1]} />;
}

export default RouteMeta;
